module.exports = __webpack_public_path__ + "img/collaborate_19.76b51cd5.jpg";